export const PLP_PATH = '/products/';
export const SEARCH_PATH = '/search';
export const MENS = "men's";
export const HOMMES = 'hommes';
export const WOMENS = "women's";
export const FEMMES = 'femmes';
export const UNISEX = 'unisex';
export const UNISEXE = 'unisexe';
export const BRAND = 'brand';
export const MARQUE = 'marque';
export const BRANDS = 'brands';
export const MARQUES = 'marques';
export const GENDER = 'gender';
export const BADGE = 'badge';
export const NEW = 'new';
export const NOUVEAU = 'nouveau';
export const SALE = 'sale';
export const ECONOMISEZ = 'économisez';
export const CLEARANCE = 'clearance';
export const LIQUIDATION = 'liquidation';
export const IDEAL_FOR = 'ideal for';
export const IDEAL_POUR = 'idéal pour';
export const ENCODED_QUESTION_MARK = '%3F';
export const POUR = 'pour ';
export const DEALS = 'deals';
export const AUBAINES = 'aubaines';
export const COLLECTIONS = 'collections';
export const ASSORTIMENT = 'assortiment';
export const BRANDSREGEX = /\/(brands|marques)\/([\w-']+)/;
export const DEALSREGEX = /\/(deals|aubaines)/;
export const NEWARRIVALSREGEX = /\/(new-arrivals|nouveau)/;
export const CLEARANCEREGEX = /\/(clearance|liquidation)/;
export const SALEREGEX = /\/(sale|economisez)/;
export const GENDERS_CATEGORY_REGEX =
  /([^\/]+)\/(mens|womens|kids|hommes|femmes|enfants)(\/)?([^\/]+)?/; // match the gender and the preceeding value to get general heading
export const GENDERS_REGEX =
  /\/(mens|womens|kids|hommes|femmes|unisex|unisexe|enfants)/;
export const COLLECTIONS_REGEX = /\/(collections|assortiment)\/([\w|-]+)/;

// Brands targeted for base-brand canonicalization (ED-304). Deep/filtered pages
// under these brands (e.g. /products/brands/the-north-face/rainwear) point their
// rel="canonical" at the main brand PLP (/products/brands/the-north-face) to
// consolidate ranking signals. Slugs match the keys in public/brands.json.
export const CANONICAL_BASE_BRAND_SLUGS = [
  'mec',
  'the-north-face',
  'salomon',
  'arcteryx',
  'outdoor-research',
];
